import { forwardRef, type ComponentPropsWithoutRef } from 'react'
import * as RxSwitch from '@radix-ui/react-switch'
import { cn } from './cn'

export type SwitchProps = Omit<
  ComponentPropsWithoutRef<typeof RxSwitch.Root>,
  'asChild'
>

export const Switch = forwardRef<HTMLButtonElement, SwitchProps>(
  ({ className, ...rest }, ref) => (
    <RxSwitch.Root ref={ref} className={cn('switch', className)} {...rest}>
      <RxSwitch.Thumb className="switch-thumb" />
    </RxSwitch.Root>
  ),
)
Switch.displayName = 'Switch'
